import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var PdfOrientationType;
(function (PdfOrientationType) {
    PdfOrientationType["LANDSCAPE"] = "LANDSCAPE";
    PdfOrientationType["PORTRAIT"] = "PORTRAIT";
})(PdfOrientationType || (PdfOrientationType = {}));
export var ExternalFileStatus;
(function (ExternalFileStatus) {
    ExternalFileStatus["UPLOADING"] = "UPLOADING";
    ExternalFileStatus["COMPLETED"] = "COMPLETED";
})(ExternalFileStatus || (ExternalFileStatus = {}));
export var UserSource;
(function (UserSource) {
    UserSource["ADCONSOLE"] = "ADCONSOLE";
    UserSource["SSO"] = "SSO";
})(UserSource || (UserSource = {}));
export var IdentityProviderType;
(function (IdentityProviderType) {
    IdentityProviderType["GOOGLE"] = "GOOGLE";
})(IdentityProviderType || (IdentityProviderType = {}));
export var DiscountValueType;
(function (DiscountValueType) {
    DiscountValueType["PERCENTAGE"] = "PERCENTAGE";
    DiscountValueType["AMOUNT"] = "AMOUNT";
})(DiscountValueType || (DiscountValueType = {}));
export var DiscountApplyTo;
(function (DiscountApplyTo) {
    DiscountApplyTo["GROSS1"] = "GROSS1";
    DiscountApplyTo["GROSS2"] = "GROSS2";
    DiscountApplyTo["GROSS3"] = "GROSS3";
    DiscountApplyTo["NET1"] = "NET1";
    DiscountApplyTo["NET2"] = "NET2";
    DiscountApplyTo["NET3"] = "NET3";
})(DiscountApplyTo || (DiscountApplyTo = {}));
export var DiscountOperationType;
(function (DiscountOperationType) {
    DiscountOperationType["DISCOUNT"] = "DISCOUNT";
    DiscountOperationType["SURCHARGE"] = "SURCHARGE";
})(DiscountOperationType || (DiscountOperationType = {}));
export var UserRole;
(function (UserRole) {
    UserRole["COMPANY_ADMIN"] = "COMPANY_ADMIN";
    UserRole["USER"] = "USER";
})(UserRole || (UserRole = {}));
export var CompanyRole;
(function (CompanyRole) {
    CompanyRole["ADMIN"] = "ADMIN";
    CompanyRole["CUSTOMER"] = "CUSTOMER";
})(CompanyRole || (CompanyRole = {}));
export var CompanyPosition;
(function (CompanyPosition) {
    CompanyPosition["SALES"] = "SALES";
    CompanyPosition["SALES_SUPPORT"] = "SALES_SUPPORT";
    CompanyPosition["ADOPS"] = "ADOPS";
    CompanyPosition["ADOPS_SALES"] = "ADOPS_SALES";
    CompanyPosition["ADOPS_SALES_SUPPORT"] = "ADOPS_SALES_SUPPORT";
})(CompanyPosition || (CompanyPosition = {}));
export var Role;
(function (Role) {
    Role["ADVERTISER"] = "ADVERTISER";
    Role["AGENCY"] = "AGENCY";
    Role["BROKER"] = "BROKER";
    Role["OTHER"] = "OTHER";
    Role["PUBLISHER"] = "PUBLISHER";
})(Role || (Role = {}));
export var EmailPlaceholder;
(function (EmailPlaceholder) {
    EmailPlaceholder["USER_EMAIL"] = "USER_EMAIL";
    EmailPlaceholder["SALES_CONTACT_EMAIL"] = "SALES_CONTACT_EMAIL";
    EmailPlaceholder["CREATOR_EMAIL"] = "CREATOR_EMAIL";
    EmailPlaceholder["ASSIGNEE_EMAIL"] = "ASSIGNEE_EMAIL";
    EmailPlaceholder["CONTACT_EMAIL"] = "CONTACT_EMAIL";
    EmailPlaceholder["RECEIVERS"] = "RECEIVERS";
    EmailPlaceholder["COMPANY_GENERAL_EMAIL"] = "COMPANY_GENERAL_EMAIL";
    EmailPlaceholder["ADMANAGEMENT_IF_BOOKED_OR_SELFBOOKED"] = "ADMANAGEMENT_IF_BOOKED_OR_SELFBOOKED";
    EmailPlaceholder["PUBLIC_COMMENT_RECEIVER"] = "PUBLIC_COMMENT_RECEIVER";
    EmailPlaceholder["CAMPAIGN_INVOICE_EMAILS"] = "CAMPAIGN_INVOICE_EMAILS";
    EmailPlaceholder["CAMPAIGN_COMMUNICATION_EMAIL"] = "CAMPAIGN_COMMUNICATION_EMAIL";
    EmailPlaceholder["CAMPAIGN_SCREENSHOT_EMAILS"] = "CAMPAIGN_SCREENSHOT_EMAILS";
    EmailPlaceholder["CAMPAIGN_CREATIVE_EMAILS"] = "CAMPAIGN_CREATIVE_EMAILS";
    EmailPlaceholder["CAMPAIGN_REPORT_EMAILS"] = "CAMPAIGN_REPORT_EMAILS";
    EmailPlaceholder["CAMPAIGN_SALES"] = "CAMPAIGN_SALES";
    EmailPlaceholder["CAMPAIGN_CREATOR"] = "CAMPAIGN_CREATOR";
    EmailPlaceholder["INVOICE_EMAILS"] = "INVOICE_EMAILS";
})(EmailPlaceholder || (EmailPlaceholder = {}));
export var Placeholder;
(function (Placeholder) {
    Placeholder["COMPANY_NAME"] = "COMPANY_NAME";
    Placeholder["CAMPAIGN_LINK"] = "CAMPAIGN_LINK";
    Placeholder["CAMPAIGN_NAME"] = "CAMPAIGN_NAME";
    Placeholder["INTERNAL_ORDER_NUMBER"] = "INTERNAL_ORDER_NUMBER";
    Placeholder["SALES_UNIT_NAME"] = "SALES_UNIT_NAME";
    Placeholder["CAMPAIGN_POSITIONS"] = "CAMPAIGN_POSITIONS";
    Placeholder["ATTACHMENT_LINKS"] = "ATTACHMENT_LINKS";
    Placeholder["MESSAGE"] = "MESSAGE";
    Placeholder["ATTACHMENT_LIST"] = "ATTACHMENT_LIST";
    Placeholder["CREATOR_NAME"] = "CREATOR_NAME";
    Placeholder["INVOICE_NUMBER"] = "INVOICE_NUMBER";
    Placeholder["SCREENSHOTS_ARCHIVE_LINK"] = "SCREENSHOTS_ARCHIVE_LINK";
    Placeholder["ACCOUNT"] = "ACCOUNT";
    Placeholder["CREATIVE_PREVIEW_LINKS"] = "CREATIVE_PREVIEW_LINKS";
    Placeholder["REFERENCE_NUMBER"] = "REFERENCE_NUMBER";
    Placeholder["CUSTOMER_NAME"] = "CUSTOMER_NAME";
    Placeholder["CAMPAIGN_SALES_NAME"] = "CAMPAIGN_SALES_NAME";
})(Placeholder || (Placeholder = {}));
export var MailTemplateType;
(function (MailTemplateType) {
    MailTemplateType["SEND_INVOICE"] = "SEND_INVOICE";
    MailTemplateType["PAYMENT_REMINDER_1"] = "PAYMENT_REMINDER_1";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_1"] = "PARTIALLY_PAID_PAYMENT_REMINDER_1";
    MailTemplateType["PAYMENT_REMINDER_2"] = "PAYMENT_REMINDER_2";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_2"] = "PARTIALLY_PAID_PAYMENT_REMINDER_2";
    MailTemplateType["PAYMENT_REMINDER_3"] = "PAYMENT_REMINDER_3";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_3"] = "PARTIALLY_PAID_PAYMENT_REMINDER_3";
    MailTemplateType["PAYMENT_PERSONAL_CALL_REMINDER"] = "PAYMENT_PERSONAL_CALL_REMINDER";
    MailTemplateType["PARTIALLY_PAID_PAYMENT_PERSONAL_CALL_REMINDER"] = "PARTIALLY_PAID_PAYMENT_PERSONAL_CALL_REMINDER";
    MailTemplateType["SEND_SCREENSHOTS"] = "SEND_SCREENSHOTS";
    MailTemplateType["SEND_POSITIONS_SCREENSHOTS"] = "SEND_POSITIONS_SCREENSHOTS";
    MailTemplateType["REQUEST_CREATIVES"] = "REQUEST_CREATIVES";
    MailTemplateType["SEND_REPORT"] = "SEND_REPORT";
    MailTemplateType["SEND_END_CAMPAIGN_REPORT"] = "SEND_END_CAMPAIGN_REPORT";
    MailTemplateType["SEND_STATE_READY"] = "SEND_STATE_READY";
    MailTemplateType["SEND_UNDERDELIVERED_REPORT"] = "SEND_UNDERDELIVERED_REPORT";
    MailTemplateType["COMMENT"] = "COMMENT";
    MailTemplateType["REPORTING_TOOL_MAIL"] = "REPORTING_TOOL_MAIL";
    MailTemplateType["OPS_CAMPAIGN_DECLINED"] = "OPS_CAMPAIGN_DECLINED";
    MailTemplateType["POSITION_EXCLUDED"] = "POSITION_EXCLUDED";
    MailTemplateType["PAYOUT_REPORT"] = "PAYOUT_REPORT";
    MailTemplateType["ACCOUNT_EXCLUDED"] = "ACCOUNT_EXCLUDED";
    MailTemplateType["OFFER_NOTIFICATION"] = "OFFER_NOTIFICATION";
    MailTemplateType["SELF_BOOKING_CAMPAIGN_ACTIVATED"] = "SELF_BOOKING_CAMPAIGN_ACTIVATED";
    MailTemplateType["CREDIT_CARD_PAYMENT_SUCCESSFUL"] = "CREDIT_CARD_PAYMENT_SUCCESSFUL";
    MailTemplateType["CREDIT_CARD_PAYMENT_FAILED"] = "CREDIT_CARD_PAYMENT_FAILED";
    MailTemplateType["SELFBOOKING_GREETING"] = "SELFBOOKING_GREETING";
    MailTemplateType["SELFBOOKING_SEND_REMINDER"] = "SELFBOOKING_SEND_REMINDER";
    MailTemplateType["SELFBOOKING_SEND_OVERDUE"] = "SELFBOOKING_SEND_OVERDUE";
    MailTemplateType["SELFBOOKING_ORDER_CONFIRMATION"] = "SELFBOOKING_ORDER_CONFIRMATION";
    MailTemplateType["SELFBOOKING_CAMPAIGN_RESUMED"] = "SELFBOOKING_CAMPAIGN_RESUMED";
    MailTemplateType["SELFBOOKING_CAMPAIGN_UNDERDELIVERY"] = "SELFBOOKING_CAMPAIGN_UNDERDELIVERY";
    MailTemplateType["SELFBOOKING_CAMPAIGN_FINISHED"] = "SELFBOOKING_CAMPAIGN_FINISHED";
    MailTemplateType["INVITATION"] = "INVITATION";
    MailTemplateType["RESTORE_PASSWORD"] = "RESTORE_PASSWORD";
    MailTemplateType["SEND_ORDER"] = "SEND_ORDER";
    MailTemplateType["SEND_OFFER"] = "SEND_OFFER";
    MailTemplateType["SEND_PRINT_PROOFS"] = "SEND_PRINT_PROOFS";
    MailTemplateType["OFFER_REJECTED"] = "OFFER_REJECTED";
    MailTemplateType["OFFER_EXPIRED"] = "OFFER_EXPIRED";
    MailTemplateType["FUNNEL_TASK_ASSIGNED_NOTIFICATION"] = "FUNNEL_TASK_ASSIGNED_NOTIFICATION";
    MailTemplateType["FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION"] = "FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION";
    MailTemplateType["FUNNEL_TASK_UNSNOOZED_NOTIFICATION"] = "FUNNEL_TASK_UNSNOOZED_NOTIFICATION";
    MailTemplateType["SECOND_FACTOR_CONFIRMATION"] = "SECOND_FACTOR_CONFIRMATION";
    MailTemplateType["REQUEST_ANALOG_CREATIVES"] = "REQUEST_ANALOG_CREATIVES";
    MailTemplateType["POST_DIGITAL_CONFIRMATION_NOTIFICATION"] = "POST_DIGITAL_CONFIRMATION_NOTIFICATION";
    MailTemplateType["POST_DIGITAL_CANCELLATION_NOTIFICATION"] = "POST_DIGITAL_CANCELLATION_NOTIFICATION";
    MailTemplateType["DRAFT_CREATIVE_NOTIFICATION"] = "DRAFT_CREATIVE_NOTIFICATION";
    MailTemplateType["CREATIVE_DEACTIVATED_NOTIFICATION"] = "CREATIVE_DEACTIVATED_NOTIFICATION";
    MailTemplateType["NO_GENERATIONS_DETECTED_ALERT"] = "NO_GENERATIONS_DETECTED_ALERT";
    MailTemplateType["BOUNCE"] = "BOUNCE";
    MailTemplateType["TICKET_STATUS_CHANGE_NOTIFICATION"] = "TICKET_STATUS_CHANGE_NOTIFICATION";
    MailTemplateType["TICKET_ASSIGNEE_CHANGE_NOTIFICATION"] = "TICKET_ASSIGNEE_CHANGE_NOTIFICATION";
    MailTemplateType["TICKET_COMMENT_NOTIFICATION"] = "TICKET_COMMENT_NOTIFICATION";
    MailTemplateType["MANUAL_DISPATCH_NOTIFICATION"] = "MANUAL_DISPATCH_NOTIFICATION";
})(MailTemplateType || (MailTemplateType = {}));
export var ClientMailTemplateType;
(function (ClientMailTemplateType) {
    ClientMailTemplateType["SEND_INVOICE"] = "SEND_INVOICE";
    ClientMailTemplateType["PAYMENT_REMINDER_1"] = "PAYMENT_REMINDER_1";
    ClientMailTemplateType["PARTIALLY_PAID_PAYMENT_REMINDER_1"] = "PARTIALLY_PAID_PAYMENT_REMINDER_1";
    ClientMailTemplateType["PAYMENT_REMINDER_2"] = "PAYMENT_REMINDER_2";
    ClientMailTemplateType["PARTIALLY_PAYMENT_REMINDER_2"] = "PARTIALLY_PAYMENT_REMINDER_2";
    ClientMailTemplateType["PAYMENT_REMINDER_3"] = "PAYMENT_REMINDER_3";
    ClientMailTemplateType["PARTIALLY_PAYMENT_REMINDER_3"] = "PARTIALLY_PAYMENT_REMINDER_3";
    ClientMailTemplateType["PAYMENT_PERSONAL_CALL_REMINDER"] = "PAYMENT_PERSONAL_CALL_REMINDER";
    ClientMailTemplateType["PARTIALLY_PAYMENT_PERSONAL_CALL_REMINDER"] = "PARTIALLY_PAYMENT_PERSONAL_CALL_REMINDER";
    ClientMailTemplateType["SEND_SCREENSHOTS"] = "SEND_SCREENSHOTS";
    ClientMailTemplateType["REQUEST_CREATIVES"] = "REQUEST_CREATIVES";
    ClientMailTemplateType["SEND_REPORT"] = "SEND_REPORT";
    ClientMailTemplateType["SEND_END_CAMPAIGN_REPORT"] = "SEND_END_CAMPAIGN_REPORT";
    ClientMailTemplateType["SEND_STATE_READY"] = "SEND_STATE_READY";
    ClientMailTemplateType["SEND_UNDERDELIVERED_REPORT"] = "SEND_UNDERDELIVERED_REPORT";
    ClientMailTemplateType["COMMENT"] = "COMMENT";
    ClientMailTemplateType["REPORTING_TOOL_MAIL"] = "REPORTING_TOOL_MAIL";
    ClientMailTemplateType["FUNNEL_TASK_ASSIGNED_NOTIFICATION"] = "FUNNEL_TASK_ASSIGNED_NOTIFICATION";
    ClientMailTemplateType["FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION"] = "FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION";
})(ClientMailTemplateType || (ClientMailTemplateType = {}));
export var PdfType;
(function (PdfType) {
    PdfType["ORDER"] = "ORDER";
    PdfType["OFFER"] = "OFFER";
    PdfType["REPORT"] = "REPORT";
    PdfType["PAYOUT_REPORT"] = "PAYOUT_REPORT";
    PdfType["PAYOUT_SUMMARY_REPORT"] = "PAYOUT_SUMMARY_REPORT";
    PdfType["INVOICE"] = "INVOICE";
    PdfType["CREDIT"] = "CREDIT";
    PdfType["CREDIT_CARD_RECEIPT"] = "CREDIT_CARD_RECEIPT";
    PdfType["POSTADMANAGER_SOLUTION_OFFER"] = "POSTADMANAGER_SOLUTION_OFFER";
    PdfType["POSTADMANAGER_DETAIL_OFFER"] = "POSTADMANAGER_DETAIL_OFFER";
    PdfType["POSTADMANAGER_TASKS_TIMETABLE"] = "POSTADMANAGER_TASKS_TIMETABLE";
    PdfType["POSTADMANAGER_INVOICE"] = "POSTADMANAGER_INVOICE";
    PdfType["POSTADMANAGER_INVOICE_ACCOUNTING_LIST"] = "POSTADMANAGER_INVOICE_ACCOUNTING_LIST";
    PdfType["POSTADMANAGER_BRIEFING"] = "POSTADMANAGER_BRIEFING";
    PdfType["SELFBOOKING_ORDER"] = "SELFBOOKING_ORDER";
    PdfType["SELFBOOKING_CAMPAIGN_RECEIPT"] = "SELFBOOKING_CAMPAIGN_RECEIPT";
    PdfType["SELFBOOKING_BALANCE_RECEIPT"] = "SELFBOOKING_BALANCE_RECEIPT";
    PdfType["SELFBOOKING_INVOICE"] = "SELFBOOKING_INVOICE";
})(PdfType || (PdfType = {}));
export var PdfRow;
(function (PdfRow) {
    PdfRow["ACCOUNT_DETAILS"] = "ACCOUNT_DETAILS";
    PdfRow["ACTOR"] = "ACTOR";
    PdfRow["ACTIVITY"] = "ACTIVITY";
    PdfRow["AD_TYPE_SIZES"] = "AD_TYPE_SIZES";
    PdfRow["ADVERTISER"] = "ADVERTISER";
    PdfRow["ADDRESSED_MAILINGS"] = "ADDRESSED_MAILINGS";
    PdfRow["AMOUNT_TOTAL"] = "AMOUNT_TOTAL";
    PdfRow["EXISTING_CUSTOMERS_EXCLUDED"] = "EXISTING_CUSTOMERS_EXCLUDED";
    PdfRow["AMOUNT_KUBA"] = "AMOUNT_KUBA";
    PdfRow["AMOUNT_AZ"] = "AMOUNT_AZ";
    PdfRow["AMOUNT_DE"] = "AMOUNT_DE";
    PdfRow["AMOUNT_FR"] = "AMOUNT_FR";
    PdfRow["AMOUNT_IT"] = "AMOUNT_IT";
    PdfRow["SHIPPING_DETAILS"] = "SHIPPING_DETAILS";
    PdfRow["NET_PRICE"] = "NET_PRICE";
    PdfRow["VAT_NUMBER"] = "VAT_NUMBER";
    PdfRow["AGENCY"] = "AGENCY";
    PdfRow["AGENCY_NET"] = "AGENCY_NET";
    PdfRow["AMOUNT"] = "AMOUNT";
    PdfRow["AMOUNT_OF_BROADCASTS"] = "AMOUNT_OF_BROADCASTS";
    PdfRow["BANK_ACCOUNT_NUMBER"] = "BANK_ACCOUNT_NUMBER";
    PdfRow["BIC_SWIFT"] = "BIC_SWIFT";
    PdfRow["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    PdfRow["BILLING_PERIOD"] = "BILLING_PERIOD";
    PdfRow["ISSUER_ADDRESS"] = "ISSUER_ADDRESS";
    PdfRow["BK_AMOUNT"] = "BK_AMOUNT";
    PdfRow["BK_PERCENTAGE"] = "BK_PERCENTAGE";
    PdfRow["BLACK_AND_WHITE"] = "BLACK_AND_WHITE";
    PdfRow["BROKER"] = "BROKER";
    PdfRow["CAMPAIGN_DURATION"] = "CAMPAIGN_DURATION";
    PdfRow["CAMPAIGN_PLANING"] = "CAMPAIGN_PLANING";
    PdfRow["CANCELLATION"] = "CANCELLATION";
    PdfRow["CHANNEL"] = "CHANNEL";
    PdfRow["CLICKS"] = "CLICKS";
    PdfRow["COLOR"] = "COLOR";
    PdfRow["COMMENT"] = "COMMENT";
    PdfRow["CONSULTANT"] = "CONSULTANT";
    PdfRow["CONTACT"] = "CONTACT";
    PdfRow["COST_CARRIER"] = "COST_CARRIER";
    PdfRow["CPM"] = "CPM";
    PdfRow["CREDIT"] = "CREDIT";
    PdfRow["CTR"] = "CTR";
    PdfRow["CUSTOMER_CONTACT"] = "CUSTOMER_CONTACT";
    PdfRow["CUSTOMER_NET"] = "CUSTOMER_NET";
    PdfRow["CUSTOMER_NUMBER"] = "CUSTOMER_NUMBER";
    PdfRow["DATE"] = "DATE";
    PdfRow["DAY"] = "DAY";
    PdfRow["DELIVERY_RATE"] = "DELIVERY_RATE";
    PdfRow["DEPOSIT_FOR"] = "DEPOSIT_FOR";
    PdfRow["DIGITAL"] = "DIGITAL";
    PdfRow["DIGITAL_TOTAL"] = "DIGITAL_TOTAL";
    PdfRow["DIGITAL_TOTAL_NET"] = "DIGITAL_TOTAL_NET";
    PdfRow["DISCOUNT_AMOUNT"] = "DISCOUNT_AMOUNT";
    PdfRow["DISCOUNT_PERCENTAGE"] = "DISCOUNT_PERCENTAGE";
    PdfRow["DISCOUNT_POSITIONS"] = "DISCOUNT_POSITIONS";
    PdfRow["EARLY_PAYMENT_TERMS"] = "EARLY_PAYMENT_TERMS";
    PdfRow["ADDITIONAL_TAX"] = "ADDITIONAL_TAX";
    PdfRow["ECPM_NET3"] = "ECPM_NET3";
    PdfRow["ELECTRONIC_BILL_IN"] = "ELECTRONIC_BILL_IN";
    PdfRow["EMAIL"] = "EMAIL";
    PdfRow["APPROVED_BY_USER_EMAIL"] = "APPROVED_BY_USER_EMAIL";
    PdfRow["END_DATE"] = "END_DATE";
    PdfRow["ENTER_INVOICE_NUMBER"] = "ENTER_INVOICE_NUMBER";
    PdfRow["EXPECTED_CREATIVES"] = "EXPECTED_CREATIVES";
    PdfRow["FIXED_PRICE"] = "FIXED_PRICE";
    PdfRow["FORMAT_SIZE"] = "FORMAT_SIZE";
    PdfRow["DOCUMENT_DATE"] = "DOCUMENT_DATE";
    PdfRow["GROSS"] = "GROSS";
    PdfRow["GROSS2"] = "GROSS2";
    PdfRow["GROSS3"] = "GROSS3";
    PdfRow["HOUR"] = "HOUR";
    PdfRow["IBAN"] = "IBAN";
    PdfRow["IMPRESSIONS"] = "IMPRESSIONS";
    PdfRow["INFORMATION"] = "INFORMATION";
    PdfRow["INTERNAL_NUMBER"] = "INTERNAL_NUMBER";
    PdfRow["INVOICE"] = "INVOICE";
    PdfRow["INVOICE_AMOUNT"] = "INVOICE_AMOUNT";
    PdfRow["INVOICE_DATE"] = "INVOICE_DATE";
    PdfRow["INVOICE_NUMBER"] = "INVOICE_NUMBER";
    PdfRow["INVOICE_THANKS"] = "INVOICE_THANKS";
    PdfRow["PREVIOUS_INVOICE_ID"] = "PREVIOUS_INVOICE_ID";
    PdfRow["INVOICE_DISCOUNT"] = "INVOICE_DISCOUNT";
    PdfRow["INVOICE_GROSS"] = "INVOICE_GROSS";
    PdfRow["INVOICE_NET"] = "INVOICE_NET";
    PdfRow["UNADDRESSED_POSITIONS"] = "UNADDRESSED_POSITIONS";
    PdfRow["IN_FAVOR_OF"] = "IN_FAVOR_OF";
    PdfRow["LIFE_TIME"] = "LIFE_TIME";
    PdfRow["LIST_PRICE"] = "LIST_PRICE";
    PdfRow["MARKETER"] = "MARKETER";
    PdfRow["MILESTONE"] = "MILESTONE";
    PdfRow["MAX_CPM"] = "MAX_CPM";
    PdfRow["MEDIA"] = "MEDIA";
    PdfRow["MONTH"] = "MONTH";
    PdfRow["NET"] = "NET";
    PdfRow["NONE"] = "NONE";
    PdfRow["NUMBER"] = "NUMBER";
    PdfRow["OFFER"] = "OFFER";
    PdfRow["ORDER"] = "ORDER";
    PdfRow["ONLINE"] = "ONLINE";
    PdfRow["ONLINE_TOTAL"] = "ONLINE_TOTAL";
    PdfRow["ONLINE_POSITIONS"] = "ONLINE_POSITIONS";
    PdfRow["PAYMENT_BY_CARD"] = "PAYMENT_BY_CARD";
    PdfRow["PAYOUT_COMMENT"] = "PAYOUT_COMMENT";
    PdfRow["PAYOUT_NUMBER"] = "PAYOUT_NUMBER";
    PdfRow["PLAYOUT"] = "PLAYOUT";
    PdfRow["PHASE"] = "PHASE";
    PdfRow["PHONE"] = "PHONE";
    PdfRow["POSITION"] = "POSITION";
    PdfRow["POSITION_COMMENT"] = "POSITION_COMMENT";
    PdfRow["POSITION_NAME"] = "POSITION_NAME";
    PdfRow["POSITION_DATE"] = "POSITION_DATE";
    PdfRow["POSTPROCESSING"] = "POSTPROCESSING";
    PdfRow["PREPARATION"] = "PREPARATION";
    PdfRow["PRINT"] = "PRINT";
    PdfRow["PRINT_MATERIAL_DEADLINE"] = "PRINT_MATERIAL_DEADLINE";
    PdfRow["PRINT_TOTAL"] = "PRINT_TOTAL";
    PdfRow["PRINT_TOTAL_NET"] = "PRINT_TOTAL_NET";
    PdfRow["PRODUCTION_SIZE"] = "PRODUCTION_SIZE";
    PdfRow["PUBLICATION_DATE"] = "PUBLICATION_DATE";
    PdfRow["PUBLISHER_PAYOUT"] = "PUBLISHER_PAYOUT";
    PdfRow["QR_IBAN"] = "QR_IBAN";
    PdfRow["QR_REFERENCE"] = "QR_REFERENCE";
    PdfRow["RADIO"] = "RADIO";
    PdfRow["RADIO_TOTAL"] = "RADIO_TOTAL";
    PdfRow["RADIO_TOTAL_NET"] = "RADIO_TOTAL_NET";
    PdfRow["RECEIPT"] = "RECEIPT";
    PdfRow["REFERENCE_NUMBER"] = "REFERENCE_NUMBER";
    PdfRow["RELEASE"] = "RELEASE";
    PdfRow["REPORT"] = "REPORT";
    PdfRow["REVENUE"] = "REVENUE";
    PdfRow["RUNTIME"] = "RUNTIME";
    PdfRow["SALES_CONTACT"] = "SALES_CONTACT";
    PdfRow["SPOT_LENGTH"] = "SPOT_LENGTH";
    PdfRow["START_DATE"] = "START_DATE";
    PdfRow["SUBCONTRACTOR"] = "SUBCONTRACTOR";
    PdfRow["TOTAL"] = "TOTAL";
    PdfRow["MAILING_TOTAL"] = "MAILING_TOTAL";
    PdfRow["ADDRESSED"] = "ADDRESSED";
    PdfRow["ADDRESSED_MAILING_TOTAL"] = "ADDRESSED_MAILING_TOTAL";
    PdfRow["EMAIL_TOTAL"] = "EMAIL_TOTAL";
    PdfRow["SERVICE"] = "SERVICE";
    PdfRow["SERVICE_TOTAL"] = "SERVICE_TOTAL";
    PdfRow["REACH"] = "REACH";
    PdfRow["TOTAL_TABLE"] = "TOTAL_TABLE";
    PdfRow["TOTAL_REACH"] = "TOTAL_REACH";
    PdfRow["TOTAL_NETTO"] = "TOTAL_NETTO";
    PdfRow["TOTAL_GROSS"] = "TOTAL_GROSS";
    PdfRow["UNADDRESSED"] = "UNADDRESSED";
    PdfRow["UNADDRESSED_MAILINGS"] = "UNADDRESSED_MAILINGS";
    PdfRow["DIGITAL_POSITIONS"] = "DIGITAL_POSITIONS";
    PdfRow["SERVICE_POSITIONS"] = "SERVICE_POSITIONS";
    PdfRow["KUREPO"] = "KUREPO";
    PdfRow["FRANKIERLIZENZ"] = "FRANKIERLIZENZ";
    PdfRow["TOP_UP_RECEIPT"] = "TOP_UP_RECEIPT";
    PdfRow["TOTAL_GROSS_VAT"] = "TOTAL_GROSS_VAT";
    PdfRow["TOTAL_INCL_VAT"] = "TOTAL_INCL_VAT";
    PdfRow["TOTAL_EXCL_VAT"] = "TOTAL_EXCL_VAT";
    PdfRow["TOTAL_NET"] = "TOTAL_NET";
    PdfRow["TOTAL_VAT"] = "TOTAL_VAT";
    PdfRow["TOTAL_NO_VAT"] = "TOTAL_NO_VAT";
    PdfRow["DOMESTIC_COUNTRY_ADDITIONAL_INFO"] = "DOMESTIC_COUNTRY_ADDITIONAL_INFO";
    PdfRow["FOREIGN_COUNTRY_ADDITIONAL_INFO"] = "FOREIGN_COUNTRY_ADDITIONAL_INFO";
    PdfRow["TV"] = "TV";
    PdfRow["TV_TOTAL"] = "TV_TOTAL";
    PdfRow["TV_TOTAL_NET"] = "TV_TOTAL_NET";
    PdfRow["TYPE"] = "TYPE";
    PdfRow["UNIQUE_IDENTIFIER"] = "UNIQUE_IDENTIFIER";
    PdfRow["USE_INVOICE_DETAILS"] = "USE_INVOICE_DETAILS";
    PdfRow["VAT"] = "VAT";
    PdfRow["VMK_AMOUNT"] = "VMK_AMOUNT";
    PdfRow["VMK_PERCENTAGE"] = "VMK_PERCENTAGE";
    PdfRow["WEEK"] = "WEEK";
    PdfRow["YOUR_VAT"] = "YOUR_VAT";
    PdfRow["DISTRIBUTION_DATE"] = "DISTRIBUTION_DATE";
    PdfRow["DELIVERY_DATE"] = "DELIVERY_DATE";
    PdfRow["NUMBER_OF_SHIPMENTS_DE"] = "NUMBER_OF_SHIPMENTS_DE";
    PdfRow["NUMBER_OF_SHIPMENTS_FR"] = "NUMBER_OF_SHIPMENTS_FR";
    PdfRow["NUMBER_OF_SHIPMENTS_IT"] = "NUMBER_OF_SHIPMENTS_IT";
    PdfRow["NUMBER_OF_SHIPMENTS"] = "NUMBER_OF_SHIPMENTS";
    PdfRow["RANGE"] = "RANGE";
    PdfRow["PRICE"] = "PRICE";
    PdfRow["LIFETIME"] = "LIFETIME";
    PdfRow["QUANTITY"] = "QUANTITY";
    PdfRow["TARGETING_BOTTOM_INFO"] = "TARGETING_BOTTOM_INFO";
    PdfRow["AFFINITIES"] = "AFFINITIES";
    PdfRow["LANGUAGES"] = "LANGUAGES";
    PdfRow["TARGET_GROUP"] = "TARGET_GROUP";
    PdfRow["TARGETING_PAGE"] = "TARGETING_PAGE";
    PdfRow["INCOMES"] = "INCOMES";
    PdfRow["GENDERS"] = "GENDERS";
    PdfRow["HOUSEHOLD_SIZES"] = "HOUSEHOLD_SIZES";
    PdfRow["AGES"] = "AGES";
    PdfRow["ANALOG"] = "ANALOG";
    PdfRow["ANALOG_TOTAL"] = "ANALOG_TOTAL";
    PdfRow["NUMBER_OF_SELECTED_BRANCHES"] = "NUMBER_OF_SELECTED_BRANCHES";
    PdfRow["SURCHARGE_AMOUNT"] = "SURCHARGE_AMOUNT";
    PdfRow["PRODUCTION"] = "PRODUCTION";
    PdfRow["FORMAT"] = "FORMAT";
    PdfRow["CATEGORY_MANAGER_DEADLINE"] = "CATEGORY_MANAGER_DEADLINE";
    PdfRow["LAYOUT_DELIVERY_DEADLINE"] = "LAYOUT_DELIVERY_DEADLINE";
    PdfRow["ADVERTISEMENTS"] = "ADVERTISEMENTS";
    PdfRow["CONTACT_EMAIL"] = "CONTACT_EMAIL";
    PdfRow["CONTACT_PHONE"] = "CONTACT_PHONE";
    PdfRow["CALENDAR_WEEK"] = "CALENDAR_WEEK";
    PdfRow["SHARE_OF_VOICE"] = "SHARE_OF_VOICE";
    PdfRow["CREATIVE_DELIVERY_DEADLINE"] = "CREATIVE_DELIVERY_DEADLINE";
    PdfRow["POINT_OF_SALE"] = "POINT_OF_SALE";
    PdfRow["POINT_OF_SALE_TOTAL"] = "POINT_OF_SALE_TOTAL";
    PdfRow["POINT_OF_SALE_TOTAL_NET"] = "POINT_OF_SALE_TOTAL_NET";
    PdfRow["CREATION_DEADLINE"] = "CREATION_DEADLINE";
    PdfRow["EXTERNAL_REFERENCE"] = "EXTERNAL_REFERENCE";
    PdfRow["RAW_MATERIAL_DEADLINE"] = "RAW_MATERIAL_DEADLINE";
    PdfRow["POS_PRINT_MATERIAL_DEADLINE"] = "POS_PRINT_MATERIAL_DEADLINE";
    PdfRow["CROSSMEDIA"] = "CROSSMEDIA";
    PdfRow["CROSSMEDIA_TOTAL"] = "CROSSMEDIA_TOTAL";
    PdfRow["CROSSMEDIA_TOTAL_NET"] = "CROSSMEDIA_TOTAL_NET";
    PdfRow["ACCOUNT_EXTERNAL_REFERENCE"] = "ACCOUNT_EXTERNAL_REFERENCE";
    PdfRow["COWO_WEEK"] = "COWO_WEEK";
    PdfRow["TARGETING_INVENTORY_FINDER_LINK"] = "TARGETING_INVENTORY_FINDER_LINK";
    PdfRow["INVOICE_CONTACT_NAME"] = "INVOICE_CONTACT_NAME";
    PdfRow["INVOICE_CONTACT_EMAIL"] = "INVOICE_CONTACT_EMAIL";
    PdfRow["DEADLINE_1"] = "DEADLINE_1";
    PdfRow["DEADLINE_2"] = "DEADLINE_2";
    PdfRow["DEADLINE_3"] = "DEADLINE_3";
    PdfRow["TOTAL_IMPRESSIONS"] = "TOTAL_IMPRESSIONS";
    PdfRow["TOTAL_CLICKS"] = "TOTAL_CLICKS";
    PdfRow["POST_BRIEFING_TITLE"] = "POST_BRIEFING_TITLE";
    PdfRow["PAM_NUMBER"] = "PAM_NUMBER";
    PdfRow["LINK_TO_CAMPAIGN"] = "LINK_TO_CAMPAIGN";
    PdfRow["GOAL"] = "GOAL";
    PdfRow["CONTENT"] = "CONTENT";
    PdfRow["CONTENT_HINT"] = "CONTENT_HINT";
    PdfRow["TEXT_INPUT_PLACEHOLDER"] = "TEXT_INPUT_PLACEHOLDER";
    PdfRow["AREA"] = "AREA";
    PdfRow["TIMING"] = "TIMING";
    PdfRow["CHANNELS"] = "CHANNELS";
    PdfRow["ADDRESSED_CHANNELS"] = "ADDRESSED_CHANNELS";
    PdfRow["ONLINE_CHANNELS"] = "ONLINE_CHANNELS";
    PdfRow["DIGITAL_CHANNELS"] = "DIGITAL_CHANNELS";
    PdfRow["EMAIL_CHANNELS"] = "EMAIL_CHANNELS";
    PdfRow["OTHER_CHANNELS"] = "OTHER_CHANNELS";
    PdfRow["BUDGET"] = "BUDGET";
    PdfRow["DISCOUNTS"] = "DISCOUNTS";
    PdfRow["ADDRESSED_LETTERS_DISCOUNT"] = "ADDRESSED_LETTERS_DISCOUNT";
    PdfRow["DENY"] = "DENY";
    PdfRow["CONFIRM"] = "CONFIRM";
    PdfRow["TEXT_PERCENTAGE"] = "TEXT_PERCENTAGE";
    PdfRow["PROMOPOST_DISCOUNT"] = "PROMOPOST_DISCOUNT";
    PdfRow["SPECIAL_DISCOUNT"] = "SPECIAL_DISCOUNT";
    PdfRow["NOTES"] = "NOTES";
    PdfRow["OFFER_UNTIL"] = "OFFER_UNTIL";
    PdfRow["OFFER_UNTIL_COMMENT"] = "OFFER_UNTIL_COMMENT";
    PdfRow["NOTE_LEADTIME"] = "NOTE_LEADTIME";
    PdfRow["WEEK_NUMBER"] = "WEEK_NUMBER";
    PdfRow["NATIVE"] = "NATIVE";
    PdfRow["ADVISOR"] = "ADVISOR";
    PdfRow["ADDRESS"] = "ADDRESS";
    PdfRow["CREDIT_CARD_LAST_4"] = "CREDIT_CARD_LAST_4";
    PdfRow["PAYOUT_DATE_PREFIX"] = "PAYOUT_DATE_PREFIX";
    PdfRow["WEBSITE_NAME"] = "WEBSITE_NAME";
    PdfRow["COST_UNIT"] = "COST_UNIT";
})(PdfRow || (PdfRow = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var OidcIssuerName;
(function (OidcIssuerName) {
    OidcIssuerName["SWISS_POST"] = "SWISS_POST";
    OidcIssuerName["COOP"] = "COOP";
})(OidcIssuerName || (OidcIssuerName = {}));
export var PrintOperationExportType;
(function (PrintOperationExportType) {
    PrintOperationExportType["ADFLOW"] = "ADFLOW";
    PrintOperationExportType["TOPAS"] = "TOPAS";
    PrintOperationExportType["CICLON"] = "CICLON";
    PrintOperationExportType["COOP"] = "COOP";
    PrintOperationExportType["NONE"] = "NONE";
})(PrintOperationExportType || (PrintOperationExportType = {}));
export var PrintCreativeExportType;
(function (PrintCreativeExportType) {
    PrintCreativeExportType["ONEVISION"] = "ONEVISION";
})(PrintCreativeExportType || (PrintCreativeExportType = {}));
export var ExternalReferenceType;
(function (ExternalReferenceType) {
    ExternalReferenceType["STRING"] = "STRING";
    ExternalReferenceType["NUMERIC"] = "NUMERIC";
})(ExternalReferenceType || (ExternalReferenceType = {}));
export var PdfMediaType;
(function (PdfMediaType) {
    PdfMediaType["DIGITAL"] = "DIGITAL";
    PdfMediaType["PRINT"] = "PRINT";
    PdfMediaType["RADIO"] = "RADIO";
    PdfMediaType["TV"] = "TV";
    PdfMediaType["POS"] = "POS";
    PdfMediaType["ANALOG"] = "ANALOG";
    PdfMediaType["CROSSMEDIA"] = "CROSSMEDIA";
    PdfMediaType["UNADDRESSED_MAILINGS"] = "UNADDRESSED_MAILINGS";
    PdfMediaType["DIGITAL_POSITIONS"] = "DIGITAL_POSITIONS";
    PdfMediaType["ADDRESSED_MAILINGS"] = "ADDRESSED_MAILINGS";
    PdfMediaType["EMAILS"] = "EMAILS";
    PdfMediaType["ONLINE_POSITIONS"] = "ONLINE_POSITIONS";
    PdfMediaType["SERVICE_POSITIONS"] = "SERVICE_POSITIONS";
    PdfMediaType["DISCOUNT_POSITIONS"] = "DISCOUNT_POSITIONS";
})(PdfMediaType || (PdfMediaType = {}));
export var UiTheme;
(function (UiTheme) {
    UiTheme["DARK"] = "DARK";
    UiTheme["LIGHT"] = "LIGHT";
    UiTheme["SYSTEM"] = "SYSTEM";
})(UiTheme || (UiTheme = {}));
